import { DateTime } from "@/util";
import { ExpandableCard } from "../../components";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useWelderStatusHistory } from "../hooks";
import { WelderStatusHistory } from "@/api/williams/welders";

export function StatusHistory({ welderId }: { welderId: string }) {
  const history = useWelderStatusHistory(welderId);
  const total = history.data?.length ?? 0;

  return (
    <ExpandableCard caption={`Status History (${total})`}>
      {history.isLoading ? (
        <p>Loading...</p>
      ) : history.isError ? (
        <p>An unknown error occurred.</p>
      ) : history.isSuccess && history.data.length > 0 ? (
        <StatusHistoryTable data={history.data} />
      ) : (
        <p>No history found.</p>
      )}
    </ExpandableCard>
  );
}

function StatusHistoryTable({ data }: { data: WelderStatusHistory[] }) {
  return (
    <table className="table table-sm table-borderless mb-0">
      <thead>
        <tr>
          <th className="col col-md-4">Event</th>
          <th className="col-4 d-none d-md-table-cell">Description</th>
          <th className="col-4 d-none d-md-table-cell">Date</th>
          <th className="col-auto" />
        </tr>
      </thead>
      <tbody>
        {data.map((row) => (
          <StatusHistoryRow key={row.id} row={row} />
        ))}
      </tbody>
    </table>
  );
}

function StatusHistoryRow({ row }: { row: WelderStatusHistory }) {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <>
      <tr>
        <td>{row.event}</td>
        <td className="d-none d-md-table-cell">{row.description}</td>
        <td className="d-none d-md-table-cell">{DateTime.getLocalDate(row.date)}</td>
        <td className="text-end text-nowrap">
          <FontAwesomeIcon
            role="button"
            icon={expanded ? faChevronUp : faChevronDown}
            size="sm"
            className="me-1"
            title="Details"
            onClick={() => setExpanded((prev) => !prev)}
            fixedWidth={true}
          />
        </td>
      </tr>
      {expanded && (
        <tr>
          <td className="d-none d-md-table-cell" colSpan={4}>
            <ExpandedDetails row={row} />
          </td>
          <td className="d-table-cell d-md-none" colSpan={2}>
            <ExpandedDetails row={row} />
          </td>
        </tr>
      )}
    </>
  );
}

function ExpandedDetails({ row }: { row: WelderStatusHistory }) {
  return (
    <div className="ms-1">
      <div className="bg-light p-1">Details</div>
      <div className="p-1">
        <dl>
          {row.description && (
            <>
              <dt className="d-block d-md-none">Description</dt>
              <dd className="d-block d-md-none">{row.description}</dd>
            </>
          )}
          {row.date && (
            <>
              <dt className="d-block d-md-none">Date</dt>
              <dd className="d-block d-md-none">{DateTime.getLocalDate(row.date)}</dd>
            </>
          )}
          {row.reason && (
            <>
              <dt>Reason</dt>
              <dd>{row.reason}</dd>
            </>
          )}
          {row.userName && (
            <>
              <dt>User</dt>
              <dd>{row.userName}</dd>
            </>
          )}
        </dl>
      </div>
    </div>
  );
}
